import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ContentService} from "../_services/content.service";
import {AuthService} from "../_services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class RouteGuard implements CanActivate {
    constructor(
        private contentService: ContentService,
        private router: Router, private authService: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let path: string = route.url.toString().replace(new RegExp(',', 'g'), '/');
        this.contentService.getCurrentDashboardCommunity().subscribe((r): void => {
            if (r) {
                this.contentService.getCommunityPages(r?.id).subscribe(resp => {
                    let notFound: boolean = true;
                    for (let page of resp.results) {
                        if (path == page.slug || page.slug?.includes(path) || path.includes(page.slug)) {
                            notFound = false;
                            this.router.navigate(['info', page.id]);
                        }
                    }
                    if (notFound) {
                        this.router.navigate(['404']);
                    }
                })
            } else {
                this.authService.logout();
            }
        });

        // Guard always returns true and loads LoadingComponent
        // request is being executed.
        return true;
    }


}
